import React, { useRef, useState } from "react";
import { Images } from "../../theme";
import { useTranslation } from "react-i18next";

export default (props) => {
  const { t } = useTranslation();

  const [image, setImage] = useState(props.source ? props.source : []);
  const inputRef = useRef(null);
  const handleClick = (inputRef) => {
    inputRef.current.click();
  };

  const deleteImage = (val, ind) => {
    let arr = [...image];
    if (arr[ind] == val) {
      if (val.updateData) {
        props.deletedImage(val);
      }
      arr.splice(ind, 1);
    }
    setImage(arr);
  };

  const handleImageChange = (e, value) => {
    if (e.target.files.length) {
      let valid = "";
      const arrFiles = Array.from(e.target.files);
      arrFiles?.map((val) => {
        let file: File = val;
        let pattern = /image-*/;
        if (!file.type.match(pattern)) {
          valid = false;
        } else {
          valid = true;
        }
      });
      if (valid) {
        if (image?.length > 0) {
          const files = arrFiles.map((file, index) => {
            const src = window.URL.createObjectURL(file);
            return { file, id: index, src };
          });
          let j = 0;
          let toSet = [];
          for (let i = image.length; i < image.length + files.length; i++) {
            toSet.push({ file: files[j].file, id: i, src: files[j].src });
            j++;
          }
          const frozenObj = Object.freeze(toSet);
          let arr = Object.freeze(image.concat(frozenObj));
          setImage(arr);
          props.imageData(arr);
        } else {
          const arrFiles = Array.from(e.target.files);
          const files = arrFiles.map((file, index) => {
            const src = window.URL.createObjectURL(file);
            return { file, id: index, src };
          });
          setImage(files);
          props.imageData(files);
        }
      } else {
        alert(t("Only_Image_Allowed"));
        setImage([]);
      }
    }
  };

  const renderAvatarAfterSelect = () => {
    return (
      <div className="row">
        {image.length > 0
          ? image.map((val, ind) => {
              return (
                <div className="col-md-4 col-4">
                  <div className="ImgCardSubProductList">
                    <div
                      className="EditItemSubImgList"
                      style={{
                        backgroundImage: `url(${val.src})`,
                      }}
                    >
                      <img
                        src={Images.close}
                        className="edit-delete-icon"
                        onClick={() => deleteImage(val, ind)}
                      />
                    </div>
                  </div>
                </div>
              );
            })
          : null}
      </div>
    );
  };

  const renderAvatarBeforeSelect = () => {
    return (
      <div className="ImgCardProductList">
        <div
          className="ListItemProductImg"
          onClick={() => handleClick(inputRef)}
        >
          <input
            type="file"
            id="img"
            multiple
            name="img"
            accept="image/*"
            ref={inputRef}
            style={{ display: "none" }}
            onChange={(e, value) => handleImageChange(e, value)}
          />
          <img className="" src={Images.uploadIconImg} />
        </div>
      </div>
    );
  };
  return (
    <>
      {renderAvatarBeforeSelect()}
      {renderAvatarAfterSelect()}
    </>
  );
};
